import type { ChatBotMessage } from "./types";

function simplifyMessages(messages: ChatBotMessage[]) {
  return messages.map(({ sender, text, timestamp }) => ({
    sender,
    text,
    timestamp,
  }));
}

export async function copySelectedMessagesToClipboard(
  messages: ChatBotMessage[],
): Promise<boolean> {
  const serialized = JSON.stringify(simplifyMessages(messages));
  try {
    if (navigator.clipboard?.writeText) {
      await navigator.clipboard.writeText(serialized);
      return true;
    }
    // Fallback: use temporary textarea + execCommand
    const ta = document.createElement("textarea");
    ta.value = serialized;
    document.body.appendChild(ta);
    ta.select();
    const ok = document.execCommand("copy");
    document.body.removeChild(ta);
    return ok;
  } catch {
    return false;
  }
}

export function bundleMessagesForOriginStorage(
  messages: ChatBotMessage[],
): string {
  const simplified = simplifyMessages(messages);
  return JSON.stringify(simplified);
}
